/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { Button, useActionsBtnContext } from '@finbeat/react-toolkit';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslateDelete } from 'models/translateWorkplace';
import { useTranslation } from 'react-i18next';
import 'scss/Main.scss';
import { useTranslateWorkplaceState } from './Translate';

export default function UserDeleteBtn({ item }: { item: TranslateDelete }) {
    const { t } = useTranslation();
    const { deleteItemMutation } = useTranslateWorkplaceState();
    const { addRequest } = useActionsBtnContext();

    return (
        <div>
            <Button
                className="workplace-delete-btn popover-btn"
                type="button"
                onClick={() => {
                    addRequest({
                        content: t('BackOfficeAreYouSure'),
                        confirmCallback: (res) => {
                            if (res && item.name && item.name) deleteItemMutation.mutate(item);
                        },
                    });
                }}
            >
                <FontAwesomeIcon
                    icon={faTrashCan}
                    className="text-danger workplace-action-btn__icon"
                />
                <span>{t('BackOfficeDelete')}</span>
            </Button>
        </div>
    );
}
